/**
 * The third-party services a node type can draw on, kept apart from the node
 * catalogue itself.
 *
 * A provider is described once here and referred to by key from however many
 * node types it feeds — Withings feeds six of them, and writing its name and
 * summary into six catalogue entries would be six places to correct when any
 * of it changes.
 *
 * Only what actually works appears here. A service the app cannot yet talk to
 * is not an integration; it is an intention, and this list is read by the
 * people using the product.
 */
export const INTEGRATION_CATALOG = [
    {
        key: 'withings',
        name: 'Withings',
        summary: 'Smart scales and blood pressure monitors that measure you at home.',
        delivery: 'push',
        url: 'https://www.withings.com',
    },
    {
        key: 'openfoodfacts',
        name: 'Open Food Facts',
        summary: 'An open, crowd-sourced database of packaged food from shops around the world.',
        delivery: 'pull',
        url: 'https://world.openfoodfacts.org',
    },
];
const byKey = new Map(INTEGRATION_CATALOG.map((integration) => [integration.key, integration]));
export function findIntegration(key) {
    return byKey.get(key);
}
/**
 * Throws rather than returning undefined: a node type naming an integration
 * that does not exist is a typo in the catalogue, and the guide showing an
 * empty slot is a worse way to find out than a failing test.
 */
export function requireIntegration(key) {
    const integration = byKey.get(key);
    if (!integration)
        throw new Error(`Unknown integration: ${key}`);
    return integration;
}
//# sourceMappingURL=integrations.js.map